// extracted by mini-css-extract-plugin
export default {"contentContainer":"Documents_contentContainer__Vk16M","content":"Documents_content__jcUkT","list":"Documents_list__kqlHL"};